import { now } from "../firebase";

export default class TestSuits {
  db: firebase.firestore.Firestore;
  collection: firebase.firestore.CollectionReference;

  constructor(db: firebase.firestore.Firestore, uid: string) {
    this.db = db;
    this.collection = db
      .collection("users")
      .doc(uid)
      .collection("testSuits");
  }

  all(): Promise<any[]> {
    return this.collection
      .orderBy("created")
      .get()
      .then(function(querySnapshot: any) {
        let testSuits: any[] = [];
        querySnapshot.forEach(function(doc: any) {
          testSuits.push({ id: doc.id, ...doc.data() });
        });
        return testSuits;
      });
  }

  create(attrs: any): Promise<any> {
    attrs = { ...attrs, created: now() };
    return this.collection.add(attrs).then(doc => ({ id: doc.id, ...attrs }));
  }

  delete(id: any): void {
    this.collection.doc(id).delete();
  }

  update(id: any, attrs: any): Promise<any> {
    return this.collection
      .doc(id)
      .set(attrs)
      .then(() => ({ id: id, ...attrs }));
  }
}
